angular.module('directives').directive('dropDownList', function () {
	return{
		restrict: 'E',
		scope: {
			selectedElement: "=",
			allElements: "=",
			name:"@",
			onSelect: "&"
		},
		template: require('./dropDownList.html'),
		link: function (scope, element, attrs) {

		}
	};
});
